import(/* webpackMode: "eager" */ "/app/src/app/about/know/page.tsx");
